export default "__VITE_ASSET__C0nJp4vg__"